import React from 'react'
import { func, object, string, bool } from 'prop-types'
import PageFlow from '../../components/PageFlow'
import RegisterMFACompleteStep from '../../components/RegisterMFACompleteStep'
import { StartRegistrationStep, RegisterStep } from './steps'
import {
  START_REGISTRATION,
  REGISTER,
  REGISTRATION_COMPLETE
} from '../../constants/mfa.setup.steps'

class SetupMFATOTP extends React.Component {
  render() {
    const { state: { isFromSettings } = {} } = this.props.location

    return (
      <PageFlow currentStep={this.props.step}>
        <PageFlow.Step name={START_REGISTRATION}>
          <StartRegistrationStep {...this.props} />
        </PageFlow.Step>
        <PageFlow.Step name={REGISTER}>
          <RegisterStep {...this.props} />
        </PageFlow.Step>
        <PageFlow.Step name={REGISTRATION_COMPLETE}>
          <RegisterMFACompleteStep isFromSettings={isFromSettings} />
        </PageFlow.Step>
      </PageFlow>
    )
  }
}

SetupMFATOTP.propTypes = {
  onPrepareRegistration: func.isRequired,
  onFinishRegistration: func.isRequired,
  onCancel: func.isRequired,
  registrationData: object,
  location: object,
  isProcessing: bool,
  errorCode: string,
  step: string
}

SetupMFATOTP.defaultProps = {
  location: { state: { isFromSettings: false } }
}

export default SetupMFATOTP
